import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
@Injectable({
  providedIn: 'root'
})
export class ChallanService {

  constructor(private http: HttpClient) {
   }

  savechallan(model: any) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    return this.http.post(environment.apiUrl + 'challan/Savechallan', model);
  }
 
  recentchallan():Observable<any>{
    return  this.http.get(environment.apiUrl + 'challan/GetRecentchallan?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  updatechallan(model: any) {
    return this.http.post(environment.apiUrl + 'challan/Updatechallan', model);
  }

  getall():Observable<any>{
    return  this.http.get(environment.apiUrl + 'challan/GetAllchallan?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  getallItem():Observable<any>{
    return  this.http.get(environment.apiUrl + 'challan/GetchallanItems?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  getbyidchallan(id){
    return  this.http.get(environment.apiUrl + 'challan/GetchallanById?id=' +id);
  }

  delete(id: any) {
    return this.http.delete(environment.apiUrl+'challan/Delete?id='+id);
  }
}
